import React, {useEffect, useState} from 'react';
import 'assets/scss/page/purchase-package-page-style.scss';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import {useSetRecoilState} from "recoil";
import OnboardBuyCard from "../../component/base/onboard-buy-card/OnboardBuyCard";
import {paymentAtom} from "../../store/PaymentStore";
import parse from "html-react-parser";
import {getMilesOrMil} from "../../util/Currency";
import {getWifiPackages} from '../../example/getWifiPackages';
import {
    getPackageDescription,
    getPackageInfo,
    getPackageInfoDesc,
    getPackageName
} from "../../util/LanguageContentManager";
import {setSimulationNumber} from '../../util/SimulationManager';

const PurchasePackagePage = (props) => {
    const {t, i18n, navigate, setLoading, flight, handleInformation} = props.props;
    const simulationNumber = setSimulationNumber();
    const setPayment = useSetRecoilState(paymentAtom);
    const [packages, setPackages] = useState([]);
    const [list, setList] = useState([]);

    const [responseType, setResponseType] = useState(0);//1-error,2-empty

    const renderPackages = () => {
        return packages.map((value, index) => {
            return (
                <OnboardBuyCard key={index}
                                title={value.title}
                                hint={value.hint}
                                content={value.content}
                                payContent={value.price + " " + (flight.domestic ? 'TL' : 'USD') + " " + t('home.or_line') + " " + value.payMIL + getMilesOrMil(i18n, value.payMIL)}
                                onClickPay={() => {
                                    setPayment(value);
                                    navigate("/payment")
                                }}
                />
            );
        })
    }

    useEffect(() => {
        simulationNumber(2, 4);
        handleInformation("purchase_package");
        let result = getWifiPackages;
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setupPackages(result.data?.data);
            setList(result.data?.data);
        }, 1000);
    }, [])


    useEffect(() => {
        setupPackages(list);
    }, [i18n.language])

    const setupPackages = (list) => {
        let data = []
        let isTrLang = /tr/.test(i18n.language.toLowerCase());
        list?.forEach(value => {
            data.push({
                title: getPackageName(i18n, value),
                content: getPackageDescription(i18n, value),
                price: flight.domestic ? value.priceTL : value.priceUSD, payMIL: value.priceMile,
                packageId: value.id,
                hint: {
                    title: getPackageInfo(i18n, value),
                    desc: getPackageInfoDesc(i18n, value)
                }
            })
        })
        setPackages(data);
    }

    return (
        <div>
            <HeaderComponent title={t('purchase_package.title')}
                             route={"/remaining-usage"}
                             content={t('purchase_package.content')} showBack/>

            <div className="content-root">

                {responseType === 1 && (
                    <p className="no-package-text m-t-150 m-b-170">{parse(t('purchase_package.error.service'))}</p>)}

                {responseType === 2 && (
                    <p className="no-package-text m-t-150 m-b-170">{t('purchase_package.error.empty')}</p>)}

                {renderPackages()}

                {responseType === 0 && (<p className="purchase-package-hint">{t('purchase_package.hint_warning')}</p>)}

            </div>

            <FooterComponent/>

        </div>
    );
};

export default PurchasePackagePage;

